module.exports = "/_next/static/images/autoMobile-78ccead672423a0d161398f614215028.svg";